import React, { ReactNode, useContext } from 'react';
import { UNSTABLE_ToastQueue as ToastQueue } from 'react-aria-components';
import { OverlayTriggerState } from 'react-stately/useOverlayTriggerState';

export interface ToastData {
  title?: ReactNode;
  content: ReactNode;
  variant: 'neutral' | 'success' | 'error';
}

export type ToastContextType = {
  queue: ToastQueue<ToastData>;
  overlayState: OverlayTriggerState;
} | null;

export const ToastContext = React.createContext<ToastContextType>(null);

export const useToastContext = (): ToastContextType | null => {
  const context = useContext(ToastContext);

  return context;
};
